import { render, staticRenderFns } from "./ModalTermAndConditios.vue?vue&type=template&id=3855df9a&scoped=true"
import script from "./ModalTermAndConditios.vue?vue&type=script&lang=js"
export * from "./ModalTermAndConditios.vue?vue&type=script&lang=js"
import style0 from "./ModalTermAndConditios.vue?vue&type=style&index=0&id=3855df9a&prod&rel=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3855df9a",
  null
  
)

export default component.exports